import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/layouts/index";
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import ProductDetailDeep from "./pages/ProductDetailDeepPage";
import ProductDetailSleek from "./pages/ProductDetailSleekPage";
import AboutPage from "./pages/AboutPage";
import ConceptPage from "./pages/ConceptPage";
import ShopPage from "./pages/ShopPage";
import TopicsPage from "./pages/TopicsPage";
import TopicDetailPage from "./pages/TopicDetailPage";
import FAQPage from "./pages/FAQPage";
import HairCheckPage from "./pages/HairCheckPage";
import TopicPreviewPage from "./pages/TopicPreviewPage";

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="products" element={<ProductPage />} />
        <Route path="product-detail-deep" element={<ProductDetailDeep />} />
        <Route path="product-detail-sleek" element={<ProductDetailSleek />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="concept" element={<ConceptPage />} />
        <Route path="shop" element={<ShopPage />} />
        <Route path="topics" element={<TopicsPage />} />
        <Route path="topic-detail/:id" element={<TopicDetailPage />} />
        <Route path="topic-preview/:id" element={<TopicPreviewPage />} />
        <Route path="faq" element={<FAQPage />} />
        <Route path="hair-check" element={<HairCheckPage />} />
      </Route>
    </Routes>
  </Router>
);

export default AppRoutes;
